export class PrizeDTO {
    
    public id: string;
    public title: string;
    public description: string;
    public details?: string;
    public value: number;
    public startDate: number[];
    public endDate?: number[];
    public ordBy: number;
    public imageUrl?: string;

    constructor() {
        this.id = '';
        this.title = '';
        this.description = '';
        this.details = '';
        this.value = 0;
        this.startDate = [];
        this.endDate = [];
        this.ordBy = 0;
        this.imageUrl = '';
    }
}